import React, { useEffect, useState } from "react";
import {
  Card,
  Grid,
  Text,
  useMantineTheme,
  UnstyledButton,
  HoverCard,
  Badge,
  Group,
  Button,
  Skeleton,
  Box,
  TextInput,
} from "@mantine/core";
import { IconPlus } from "@tabler/icons";
import { showNotification } from "@mantine/notifications";
import { apiWithInterceptor } from "../../../../api";
import { useNavigate } from "react-router-dom";
import { openConfirmModal } from "@mantine/modals";
import Pagination from "../Events/Pagination";

export default function Forms() {
  const theme = useMantineTheme();
  const [loading, setLoading] = useState(false);
  const [forms, setForms] = useState([]);
  const [deleteFlag, setDelete] = useState(false);
  const [searchForForm, setSearchForForm] = useState("");
  const [ItemPerPage, setItemPerPage] = useState(9);
  const [total, setTotal] = useState();
  const [activePage, setPage] = useState(1);
  const [offset, setOffset] = useState(0);
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("userInfo"));
  const openDeleteModal = (id) =>
    openConfirmModal({
      title: "Delete Form",
      centered: true,
      children: (
        <Text size="sm">
          Are you sure you want to delete this form? This action is destructive
          and <span style={{ color: "red", fontWeight: "bold" }}>CANNOT</span>{" "}
          be undone.
        </Text>
      ),
      labels: { confirm: "Delete Form", cancel: "Cancel" },
      confirmProps: { color: "red" },

      onConfirm: () => {
        apiWithInterceptor
          .delete(
            `/form/${id}`,

            setDelete(true)
          )
          .then(function () {
            showNotification({
              title: "Seccess",
              message: "Form deleted successfully",
              color: "green",
            });
            setLoading(false);
            setDelete(false);
          })
          .catch(function (error) {
            showNotification({
              title: "Something went wrong",
              message: ` ${error?.response?.data?.message}`,
              color: "red",
            });
            setDelete(false);
          });
      },
    });

  useEffect(() => {
    setLoading(true);
    user?.privileges === "ADMIN"
      ? apiWithInterceptor
          .get(
            `/form?limit=${ItemPerPage}&offset=${offset}&relations[]=user&relations[]=fields`
          )
          .then(function (response) {
            setForms(response?.data?.array);
            setTotal(response?.data?.count);
            setLoading(false);
            setDelete(false);
          })
          .catch(function (error) {
            showNotification({
              title: "Something went wrong",
              message: ` ${error?.response?.data?.message}`,
              color: "red",
            });
          })
      : apiWithInterceptor
          .get(
            `/form?limit=${ItemPerPage}&offset=${offset}&relations[]=fields.answers&user_id=${user?.id}`
          )
          .then(function (response) {
            setForms(response?.data?.array);
            setLoading(false);
            setDelete(false);
          })
          .catch(function (error) {
            showNotification({
              title: "Something went wrong",
              message: ` ${error?.response?.data?.message}`,
              color: "red",
            });
          });
  }, [deleteFlag, offset]);

  const skeleton = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  return (
    <>
      <Box
        sx={{
          width: "100%",
          maxWidth: "1000px",
          margin: "auto",
        }}
      >
        <Grid>
          <Grid.Col xs={12}>
            <UnstyledButton
              onClick={() => {
                navigate("/app/createform");
              }}
              sx={{ marginTop: "1em", width: "100%" }}
            >
              <Card
                shadow="sm"
                p="lg"
                radius="md"
                withBorder
                sx={{
                  height: "5em",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  transition: ".3s",
                  "&:hover": {
                    borderColor: theme.colors.brand[5],
                    backgroundColor: `${theme.colors.brand[9]}02`,
                  },
                }}
              >
                <Text>Create New Form</Text>
                <IconPlus />
              </Card>
            </UnstyledButton>
          </Grid.Col>
          <Grid.Col
            xs={12}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <TextInput
              style={{
                width: "100%",
              }}
              label="Search for form"
              placeholder="Enter a form name to search for"
              onChange={(e) => {
                setSearchForForm(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  apiWithInterceptor
                    .get(
                      `/form?relations[]=user&relations[]=fields&user_id=${user.id}&name=${searchForForm}`
                    )
                    .then((res) => {
                      setForms(res.data.array);
                    });
                }
              }}
            />
          </Grid.Col>
          {loading ? (
            <>
              {skeleton.map((item, index) => {
                return (
                  <Grid.Col
                    key={index}
                    sm={4}
                    sx={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Skeleton
                      id={item}
                      sx={{
                        marginLeft: "20px",
                        marginTop: "20px",
                        height: "20em",
                        width: "17em",
                      }}
                    />
                  </Grid.Col>
                );
              })}
            </>
          ) : (
            forms.map((item, index) => (
              <Grid.Col
                sm={4}
                xs={12}
                lg={4}
                key={index}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <HoverCard width={350}>
                  <Card
                    withBorder
                    shadow="sm"
                    p="lg"
                    radius="md"
                    sx={{
                      height: "320px",
                      width: "250px",
                      display: "flex",
                      marginTop: "20px",
                      flexDirection: "column",
                      //justifyContent: "center",
                      alignItems: "center",
                      transition: ".3s",
                      "&:hover": {
                        borderColor: theme.colors.brand[5],
                        backgroundColor: `${theme.colors.brand[9]}02`,
                      },
                    }}
                  >
                    <Card.Section
                      withBorder
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <HoverCard.Target>
                        <Text
                          fz="xl"
                          fw={700}
                          mt={15}
                          sx={{
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {item.name}
                        </Text>
                      </HoverCard.Target>
                      {user.privileges === "ADMIN" ? (
                        <Text
                          fz="sm"
                          fw={500}
                          sx={{
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                          color="dimmed"
                        >
                          <Text
                            span
                            fz="sm"
                            fw={500}
                            mt={15}
                            sx={{
                              textOverflow: "ellipsis",
                              maxWidth: "200px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                            }}
                            color="dimmed"
                          >
                            Creator:
                          </Text>
                          {item?.user?.username}
                        </Text>
                      ) : null}
                      <Badge
                        variant="dot"
                        mb={15}
                        mt={15}
                        color={item?.fields?.length === 0 ? "red" : "yellow"}
                      >
                        Number of Fields{" "}
                        <Text span fw={"bold"}>
                          {item?.fields?.length}
                        </Text>
                      </Badge>
                    </Card.Section>

                    <Card.Section
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Group
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "row",
                        }}
                        position="apart"
                        mt="md"
                        mb="xs"
                      >
                        <Button
                          onClick={() => {
                            navigate(`/app/edit-form/${item.id}`);
                          }}
                          compact
                          variant="filled"
                          sx={{ width: "150px" }}
                        >
                          Edit Form
                        </Button>
                        <Button
                          compact
                          variant="filled"
                          sx={{ width: "150px" }}
                          onClick={() => {
                            setDelete(true);
                            apiWithInterceptor
                              .post(`/form/duplicate`, { form_id: item.id })
                              .then((res) => {
                                console.log(res);
                                setDelete(false);
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          }}
                        >
                          Duplicate Form
                        </Button>
                        <Button
                          compact
                          variant="filled"
                          color="red"
                          uppercase
                          sx={{ width: "150px" }}
                          onClick={() => {
                            openDeleteModal(item.id);
                          }}
                        >
                          Delete Form
                        </Button>
                      </Group>
                    </Card.Section>
                  </Card>
                  <HoverCard.Dropdown sx={{ borderColor: "#edb40d" }}>
                    <Text size="lg">{item.name}</Text>
                  </HoverCard.Dropdown>
                </HoverCard>
              </Grid.Col>
            ))
          )}
          <Grid.Col
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <Pagination
              setOffset={setOffset}
              total={total}
              setPage={setPage}
              activePage={activePage}
              ItemPerPage={ItemPerPage}
              setItemPerPage={setItemPerPage}
            />
          </Grid.Col>
        </Grid>
      </Box>
    </>
  );
}
